import { ObservabilitySystem } from '@packages/shared/core/common/observability/interfaces';
import { HttpClient } from './core/HttpClient';
import { AxiosHttpClient } from './implementations/AxiosHttpClient';
import { WithAuthorization } from './decorators/WithAuthorization';
import { WithRequestId } from './decorators/WithRequestId';
import { WithObservability } from './decorators/WithObservability';
import { WithPlatform } from './decorators/WithPlatform';

export class HttpClientBuilder {
  private httpClient: HttpClient;

  constructor(baseUrl: string) {
    this.httpClient = new AxiosHttpClient(baseUrl);
  }

  addAuthorization(token: string): this {
    this.httpClient = new WithAuthorization(this.httpClient, token);
    return this;
  }

  addObservability(observabilitySystem: ObservabilitySystem): this {
    this.httpClient = new WithObservability(this.httpClient, observabilitySystem);
    return this;
  }

  addPlatform(): this {
    this.httpClient = new WithPlatform(this.httpClient);
    return this;
  }

  addRequestId(): this {
    this.httpClient = new WithRequestId(this.httpClient);
    return this;
  }

  getResult(): HttpClient {
    return this.httpClient;
  }
}
